/**
 * Created by Smile on 2017/9/2.
 */
import * as $ajax from '../router/http'
import * as Util from 'util'
const prefix = '/v2'

/**
 * 获取消息动态列表
 * @param {object} params
 * @param {function} params.callback 回调函数
 * @param {string} params.uid 用户id
 *@param {string} params.page_num 当前页码
 *@param {string} params.page_size 每页显示条数
 */
export function getDynamicList (params) {
  let url = prefix + '/message/list_msg'
  url += '?page_num=' + params.page_num + '&page_size=' + params.page_size + '&is_update=false'
  return $ajax.ajaxGet(encodeURI(url))
}
/**
 * 获取@我的评论列表
 * @param {object} params
 * @param {function} params.callback 回调函数
 * @param {string} params.uid 用户id
 *@param {string} params.page_num 当前页码
 *@param {string} params.page_size 每页显示条数
 *@param {string} params.is_need_total 总条数
 */
export function getCommentList (params) {
  let url = prefix + '/comment/list_comment'
  url += '?page_num=' + params.page_num + '&num_each_page=' + params.num_each_page + '&is_need_total=' + params.is_need_total
  return $ajax.ajaxGet(encodeURI(url))
}
/**
 * 获取公告列表
 * @param {object} params
 * @param {function} params.callback 回调函数
 * @param {string} params.limit 文件列表条数限制  从0开始
 * @param {string} params.offset 文件列表起始偏移量  从0开始
 * @param {string} params.sort 排序规则 asc，desc ，默认desc
 */
export function getNoticeList (params) {
  let url = prefix + '/notice/pull'
  var queryString = []
  if (params.limit) {
    queryString.push('limit=' + parseInt(params.limit))
  }
  if (params.offset !== undefined) {
    queryString.push('offset=' + parseInt(params.offset))
  }
  if (queryString.length > 0) {
    url += '?' + queryString.join('&')
  }
  return $ajax.ajaxGet(encodeURI(url))
}
/**
 * （动态全部清空）
 @param {object} params
 @param {function} params.callback 回调函数
 @param {object} params.snapshot 这里存放metaData返回的数据
 */
export function cleanMsg () {
  var url = prefix + '/message/clear_msg'
  var json = {
    uid: Util.getUserId()
  }
  var postData = 'json = ' + JSON.stringify(json)
  return $ajax.ajaxPost(encodeURI(url), postData)
}
/**
 * （@我的评论全部清空）
 @param {object} params
 @param {function} params.callback 回调函数
 */
export function cleanComment () {
  var url = prefix + '/comment/clear_comment'
  var postData = {}
  return $ajax.ajaxPost(encodeURI(url), postData)
}
/**
 * 获取消息动态小红点
 * @param {object} params
 * @param {function} params.callback 回调函数
 * @param {string} params.uid 用户id
 *@param {string} params.page_num 当前页码
 *@param {string} params.page_size 每页显示条数
 */
export function getRedpoint () {
  var url = prefix + '/comment/get_redpoint'
  return $ajax.ajaxGet(encodeURI(url))
}
/**
 * 设置消息为已读
 * @param params
 * @param {array} params.logIds 消息id
 * @param {function} params.callback 回调函数
 */
export function setMsgStatus (params) {
  var url = prefix + '/message/set_msg_status'
  var postData = {
    logId: params.logId
  }
  return $ajax.ajaxPost(encodeURI(url), postData)
}
/**
 * 设置评论为已读
 * @param params
 * @param {array} params.lastedTime 消息id
 * @param {function} params.callback 回调函数
 */
export function setCommentStatus (params) {
  var url = prefix + '/comment/batch_update'
  var postData = {
    latestId: params.lastedId
  }
  return $ajax.ajaxPost(encodeURI(url), postData)
}
/**
 * 公告未读变已读
 @param {object} params
 @param {function} params.callback 回调函数
 */
export function setNoticeStatus (params) {
  var url = prefix + '/notice/batch_modify'
  var postData = {
    latestId: params.lastedId
  }
  return $ajax.ajaxPost(encodeURI(url), postData)
}



// WEBPACK FOOTER //
// ./src/SDK/MessageManager.js